import Mousetrap from 'mousetrap'

import { state as _state, ui as _ui, live, prefs } from './stores.js';
import { get } from 'svelte/store';
import { saveGame } from './save.js';
import { allActions, getActions, cardSearch, closeAllLooks, awayTeam, matches } from './card_actions.js';
import { doAction, moveTo, getPlayerIndex, getNeutralZone, undo, allCards, closeWorkingLog } from './game.js';
import { activePlayer, advance, pushChoice, skipForManualAction, withTurnHeld } from './ui.js';
import { isMe } from './net.js';
import { executeArbitraryText } from './debug.js';

let otherShortcuts = {
    //'w': () => { if(!context.waiting || !context.waiting[0] || !context.waiting[0].hasOwnProperty('choices')) drawCard(viewing)},
    //'1': () => {alterTokens(1)},
    //'shift+1': () => {alterTokens(-1)},
    //'2': () => {alterTokens(2)},
    //'shift+2': () => {alterTokens(-2)},
    //'3': () => {alterTokens(3)},
    //'shift+3': () => {alterTokens(-3)},
    'up': () => { alterTokens(1)},
    'down': () => { alterTokens(-1)},
    'v': () => { _ui.update(ui => { ui.showingLog = !ui.showingLog; return ui })},
    '?': () => { _ui.update(ui => { ui.showingHelp = !ui.showingHelp; return ui }) },
    'shift+s': () => saveGame,
    'mod+z': () => undo,
    'return': () => { 
        let ui = get(_ui);
        let state = get(_state);
        if(ui.waiting[0] && ui.waiting[0].cost){
            advance(ui.waiting[0].cost);
        }else if(ui.waiting[0] && ui.waiting[0].cards && ui.waiting[0].hasOwnProperty('number')){
            if(!ui.waiting[0].condition || ui.waiting[0].condition(ui, state)) advance(ui.multiSelection);
        }else if(ui.waiting[0] && ui.waiting[0].cards){
            if(!ui.waiting[0].condition || ui.waiting[0].condition(ui, state)) advance(ui.selection);
        }else if(ui.waiting[0] && ui.waiting[0].hasOwnProperty('choices')){
            advance(ui.waiting[0].choices[0]);
        }else if(ui.selection){
            doAction(state.players[ui.seat], 'play_activate', {card: ui.selection.uniqueID})
        }else if(ui.hintCard && ui.hintCard.autoAction){
            ui.hintCard.autoAction();
        }else if(ui.waiting[0] && !ui.waiting[0].hasOwnProperty('choices')){
            advance();
        }
            
    },
    'f': cardSearch,
    '! x': executeArbitraryText,
    '! r e a c t shift+return': async () => {
        let aug = allCards().find(c => matches(c, 'augmentation plague'));
        let qow = allCards().find(c => matches(c, 'qowat'));
        let riv = allCards().find(c => matches(c, 'riva'))
        let kti = allCards().find(c => matches(c, `k'tinga`));
        let p2 = get(_state).players[1];
        await moveTo(aug, `players.fleet.0`);
        await moveTo(qow, `players.fleet.1`);
        await moveTo(riv, `players.duty.0`);
        await moveTo(kti, `players.hand.1`);
        p2.military = 2;
    },
    '! m a x shift+return': async () => {
        if(!confirm('enter maxxed deck testing mode?')) return;
        for(let p of get(_state).players){
            p.military = 15;
            p.influence = 15;
            p.research = 15;
            p.dilithium = 10;
            p.latinum = 10;
            p.glory = 10;
            p.actions = 50;
            for(let c of getNeutralZone()){
                await awayTeam(p, c, 1, true);
            }
            for(let c of [...p.decks.deck, ...p.decks.reserve, ...p.decks.dev]){
                await moveTo(c, `players.hand.${getPlayerIndex(p)}`)
            }
        } 
    },
    // Pull the parse-time-binding test cards into hand. Each exercises a backreference the
    // "Resolve backreferences from parse-time bindings" toggle (Options -> Debug) changes.
    // See docs/prev-obj-static-binding-plan.md. Whatever isn't in this game's boxes is skipped.
    '! b n d shift+return': async () => {
        const testCards = [
            '8TOS16/29',  // Lt. Galloway   – self: "beam this card to the same location"
            '1BUR20/26',  // Keyla Detmer   – prevPrep: "the location you warped to"
            '1PIC07/24',  // Starbase 74    – slot: "free play the found card"
            '1SIS06/25',  // Self-Repl Mines– bare "it": "discard one of them"
            '1KOL05/24',  // Boreth         – it+num referring to a found card
            '1SEL07/24',  // Scimitar       – multiple refs: "destroy the found card", then more
            '1SHR03/24',  // Aenar          – "log one of the drawn cards", "discard the others"
            '2KIRK04/25', // What have I done– away-team/ship backreference
            '2REB02/22',  // Mondor         – "the gained card"
            '4BQ07/32',   // Locutus        – "assimilate one of the gained"
            '4BQ17/32',   // Existence...    – gained-card + count reference
            '4BQ22/32',   // We are the Borg – beamed-card backreference
            '6MAR01/25',  // General Martok  – enlist/self reference
            '5WOR10/25',  // Chancellor Martok– "if the discarded card is [[imperial]]"
            '5CUL08/26',  // Seska (unmasked)– away-team "them" reference
        ];
        let p = get(_state).players[get(_ui).seat];
        let idx = getPlayerIndex(p);
        let found = [], missing = [];
        for(let id of testCards){
            let c = allCards(true).find(c => c.id == id);
            if(c){ await moveTo(c, `players.hand.${idx}`); found.push(id); }
            else missing.push(id);
        }
        console.log('bind-test: pulled to hand', found, 'missing', missing);
        alert(`Pulled ${found.length}/${testCards.length} bind-test cards into hand.`
            + (missing.length ? `\nNot in this game's boxes: ${missing.join(', ')}` : ''));
    },
    '! s': () => {
        prefs.update(p => {
            p.showCardScores = !p.showCardScores;
            return p;
        })
    },
    '! l': () => {
        closeWorkingLog();
    },
    'x': closeAllLooks,
    'esc': () => {
        let ui = get(_ui);
        live.update(l => {
            l.previewDashboard = false;
            return l;
         });
         _ui.update(ui => {
            ui.dashboardSelected = false;
            return ui;
         })
        if(ui.waiting[0] && ui.waiting[0].cancellable) advance('cancelled');
    },
    '.': () => {
            if(get(live).hoveringCard){
                _ui.update(ui => {
                    ui.selection = get(live).hoveringCard;
                    return ui;
                })
            }
    },
    'ctrl-z': undo,
}

function alterTokens(amount){
    let ui = get(_ui);
    if(!ui.tokenAlteringFunction) return;
    ui.tokenAlteringFunction(amount);
}

function currentCard(){
    let l = get(live);
    if(l.previewCard) return l.previewCard
    if(l.hoveringCard) return l.hoveringCard;
    if(get(_ui).selection) return get(_ui).selection;
    return false;
}

export function setupShortcuts(){
    for(let s of Object.keys(otherShortcuts)){
        Mousetrap.bind(s, () => { 
            if(!isMe(activePlayer())) return; // Don't allow to interfere with state when not active
            otherShortcuts[s](); return false; 
        });
    }

    for(let a of allActions){
        if(a.allShortcut){
            Mousetrap.bind(a.allShortcut, async () => {
                if(!isMe(activePlayer())) return; // Don't allow to interfere with state when not active
                let p = get(_state).players[get(_ui).seat];
                // Log the action this resolved to, not the key that was pressed.
                // Catch-up then calls doAction directly. Replaying the keystroke
                // instead re-ran this handler on the other client, where the
                // isMe() guard above is false and `ui.seat` is a different
                // player, so the choice silently did nothing there.
                pushChoice({act: a.type, card: false, p});
                await doAction(p, a.type, {}); return false;
            });
        }else if(a.cardShortcut){
            // Held so a skipped prompt can't move the turn on before the action resolves
            Mousetrap.bind(a.cardShortcut, () => withTurnHeld(async () => {
                if(!isMe(activePlayer())) return; // Don't allow to interfere with state when not active

                // Skips first, so everything below is a pure read: the card and
                // its available actions are whatever the player is looking at
                // once any auto-advancing waits have cleared.
                await skipForManualAction();

                console.log('firing shortcut: resetting cache');
                _state.update(s => {
                    s.cache = {
                        allPrev: [],
                    };
                    delete s.payingCost;
                    return s;
                })

                let card = currentCard();
                let action = card && allActions
                    .filter(ac => ac.cardShortcut == a.cardShortcut)
                    .find(ac => getActions(card).includes(ac));

                if(!action){
                    // A key that resolves to no action is not a game choice, so
                    // nothing goes in the log: the fallback below is UI-only and
                    // must not be replayed on anyone else's client.
                    if(otherShortcuts.hasOwnProperty(a.cardShortcut)){
                        otherShortcuts[a.cardShortcut]();
                    }else{
                        console.log(`Key ${a.cardShortcut} pressed, but cannot take action ${a.type} as not available`)
                    }
                    return;
                }

                let p = get(_state).players[get(_ui).seat];
                pushChoice({act: action.type, card: card.uniqueID, p});
                await doAction(p, action.type, {card: card.uniqueID});
                return;
            }));
        }
       
    }
}


